/**
 * Formats pixel values.
 *
 * @param {number} value
 */
export const pixel = (value) => value + 'px';
//# sourceMappingURL=units.js.map